export class StoreUserModel {
    id: string;
    username: string;
}